import { expValEquals } from '@confluence/feature-experiments';

// TODO:EDITOR-2435 remove `dense` when cleaning up 'confluence_content_mode_replace_dense_with_compact'
export type UiContentMode = 'dense' | 'standard' | 'compact';
// TODO:EDITOR-2435 remove `DENSE` when cleaning up 'confluence_content_mode_replace_dense_with_compact'
export type ServerContentMode = 'DENSE' | 'STANDARD' | 'COMPACT';

export type ContentStatus = 'DRAFT' | 'CURRENT';
export type QueryContentStatus = 'draft' | 'current';

/**
 * Convert a server-reported content mode to the UI representation.
 * Defaults to "standard" for unknown or missing values.
 */
export const serverToUiContentMode = (server?: unknown): UiContentMode => {
	if (typeof server === 'string') {
		const v = server.toLowerCase();
		if (
			v ===
			(expValEquals('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test')
				? 'compact'
				: 'dense')
		)
			return expValEquals('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test')
				? 'compact'
				: 'dense';
	}
	return 'standard';
};

/**
 * Convert a UI-selected content mode to the server value.
 */
export const uiToServerContentMode = (ui: UiContentMode): ServerContentMode =>
	ui ===
	(expValEquals('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test')
		? 'compact'
		: 'dense')
		? expValEquals('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test')
			? 'COMPACT'
			: 'DENSE'
		: 'STANDARD';

/**
 * Toggle between compact and standard UI modes.
 */
export const flipContentMode = (m: UiContentMode): UiContentMode =>
	m ===
	(expValEquals('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test')
		? 'compact'
		: 'dense')
		? 'standard'
		: expValEquals('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test')
			? 'compact'
			: 'dense';

/**
 * Resolve content status (DRAFT/CURRENT) based on page context.
 */
export const resolveContentStatus = (opts: {
	isLivePage: boolean;
	isEditorPage: boolean;
}): ContentStatus => {
	if (opts.isLivePage) return 'CURRENT';
	if (opts.isEditorPage) return 'DRAFT';
	return 'CURRENT';
};

/**
 * Map a "draftness" boolean to the content query status.
 */
export const queryStatusFor = (isDraft: boolean): QueryContentStatus =>
	isDraft ? 'draft' : 'current';
